import { BLOCK_TYPES, renderSettingsShortnLong } from "../../common/";

const { LONG_ANSWER_BLOCK } = BLOCK_TYPES;

const renderSettingsLongAnswer = (block: any) =>
    renderSettingsShortnLong(block, LONG_ANSWER_BLOCK);

export default renderSettingsLongAnswer;
